import React from 'react';

import { RichTextBlock } from '../../../../core/system/rendering/helpers/index.js';
import { safeParse } from './safeParse.js';

const ListPageDescription: React.FC<{ description: string }> = ({
  description,
}) => {
  const parsedDescription = safeParse(description);

  return (
    <div className="description">
      {typeof parsedDescription === 'string'
        ? parsedDescription
        : parsedDescription.map((e, i) => (
            <RichTextBlock key={i} content={e} />
          ))}
    </div>
  );
};

export default ListPageDescription;
